import { Component, computed } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/input';
import { MatOption, MatSelect } from '@angular/material/select';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectInsuranceCategories } from '../../../store/profile/profile.state';
import { selectShipmentEditorInsuranceCategory } from '../../../store/shipment-editor/shipment-editor.state';
import { shipmentEditorSetOption } from '../../../store/shipment-editor/shipment-editor.actions';
import { ShipmentOption } from '../../../enum/shipment-option.enum';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'app-shipment-insurance',
    imports: [
        MatFormField,
        MatLabel,
        MatSelect,
        MatOption
    ],
    templateUrl: './shipment-insurance.component.html',
    styleUrl: './shipment-insurance.component.scss'
})
export class ShipmentInsuranceComponent {

    constructor(private store: Store<AppState>) {}

    public insuranceCategories = this.store.selectSignal(selectInsuranceCategories);
    public currentCategoryId = this.store.selectSignal(selectShipmentEditorInsuranceCategory);
    public currentCategory = computed(
        () => this.insuranceCategories().find(c => c.id === this.currentCategoryId())
    );

    changeInsuranceCategory(id: string): void {
        this.store.dispatch(shipmentEditorSetOption({ option: ShipmentOption.INSURANCE_CATEGORY, value: id }));
    }

}
